(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Renders the "Upcoming tour dates" list from a merged JSON blob (curated
  // theme-block tour dates + approved booking-block metaobject entries) and
  // sorts everything chronologically by start date. This runs client-side
  // because Liquid can't sort two differently-shaped collections together —
  // the alternative would be forcing both sources into one metaobject.
  ready(function () {
    var tourListEl = document.querySelector('[data-ys-tour-list]');
    var tourDataEl = document.querySelector('[data-ys-tour-data]');
    if (!tourListEl || !tourDataEl) return;

    var tourRaw = [];
    try {
      tourRaw = JSON.parse(tourDataEl.textContent);
    } catch (e) {
      tourRaw = [];
    }

    function parseTourDate(str) {
      if (!str) return null;
      var parts = str.split('-');
      if (parts.length !== 3) return null;
      var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      return isNaN(d.getTime()) ? null : d;
    }

    var tourEntries = [];
    for (var i = 0; i < tourRaw.length; i++) {
      var parsed = parseTourDate(tourRaw[i].start);
      tourEntries.push({
        sortKey: parsed ? parsed.getTime() : Infinity, // undated entries sort last, never dropped
        data: tourRaw[i]
      });
    }

    tourEntries.sort(function (a, b) {
      return a.sortKey - b.sortKey;
    });

    var tourFrag = document.createDocumentFragment();
    for (var j = 0; j < tourEntries.length; j++) {
      var item = tourEntries[j].data;

      var li = document.createElement('li');
      li.className = 'ys-tour-dates__item';

      var dateEl = document.createElement('div');
      dateEl.className = 'ys-tour-dates__date';
      dateEl.textContent = item.date_label || '';
      li.appendChild(dateEl);

      var detailsEl = document.createElement('div');
      detailsEl.className = 'ys-tour-dates__details';

      var nameEl = document.createElement('div');
      nameEl.className = 'ys-tour-dates__name';
      nameEl.textContent = item.name || '';
      detailsEl.appendChild(nameEl);

      if (item.venue) {
        var venueEl = document.createElement('div');
        venueEl.className = 'ys-tour-dates__venue';
        venueEl.textContent = item.venue;
        detailsEl.appendChild(venueEl);
      }

      if (item.event_link || item.maps_link) {
        var linksEl = document.createElement('div');
        linksEl.className = 'ys-tour-dates__links';

        if (item.event_link) {
          var eventA = document.createElement('a');
          eventA.href = item.event_link;
          eventA.target = '_blank';
          eventA.rel = 'noopener';
          eventA.textContent = 'Event info';
          linksEl.appendChild(eventA);
        }

        if (item.maps_link) {
          var mapsA = document.createElement('a');
          mapsA.href = item.maps_link;
          mapsA.target = '_blank';
          mapsA.rel = 'noopener';
          mapsA.textContent = 'View map';
          linksEl.appendChild(mapsA);
        }

        detailsEl.appendChild(linksEl);
      }

      li.appendChild(detailsEl);
      tourFrag.appendChild(li);
    }

    tourListEl.appendChild(tourFrag);
  });

  ready(function () {
    var root = document.querySelector('[data-ys-calendar]');
    if (!root) return;

    var blockedDataEl = document.querySelector('[data-ys-cal-blocked]');
    var blockedRaw = [];
    if (blockedDataEl) {
      try {
        blockedRaw = JSON.parse(blockedDataEl.textContent);
      } catch (e) {
        blockedRaw = [];
      }
    }

    function parseDate(str) {
      if (!str) return null;
      var parts = str.split('-');
      if (parts.length !== 3) return null;
      return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    }

    var blockedRanges = [];
    for (var i = 0; i < blockedRaw.length; i++) {
      var start = parseDate(blockedRaw[i].start);
      var end = parseDate(blockedRaw[i].end);
      if (start && end) {
        blockedRanges.push({
          start: start,
          end: end,
          label: blockedRaw[i].label,
          status: blockedRaw[i].status === 'pending' ? 'pending' : 'approved'
        });
      }
    }

    function isBlocked(date) {
      for (var i = 0; i < blockedRanges.length; i++) {
        var r = blockedRanges[i];
        if (date >= r.start && date <= r.end) return r;
      }
      return null;
    }

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var viewYear = today.getFullYear();
    var viewMonth = today.getMonth();

    var selectionStart = null;
    var selectionEnd = null;

    var grid = root.querySelector('[data-ys-cal-grid]');
    var weekdaysEl = root.querySelector('[data-ys-cal-weekdays]');
    var monthBtn = root.querySelector('[data-ys-cal-month-btn]');
    var yearBtn = root.querySelector('[data-ys-cal-year-btn]');
    var picker = root.querySelector('[data-ys-cal-picker]');
    var pickerLabel = root.querySelector('[data-ys-cal-picker-label]');
    var pickerGrid = root.querySelector('[data-ys-cal-picker-grid]');
    var pickerPrevBtn = root.querySelector('[data-ys-cal-picker-prev]');
    var pickerNextBtn = root.querySelector('[data-ys-cal-picker-next]');
    var prevBtn = root.querySelector('[data-ys-cal-prev]');
    var nextBtn = root.querySelector('[data-ys-cal-next]');
    var selectedText = root.querySelector('[data-ys-cal-selected-text]');
    var continueBtn = root.querySelector('[data-ys-cal-continue]');

    // Drive the picker's visibility entirely through inline styles rather than
    // the `hidden` attribute or a CSS class — a class-based `display` rule can
    // out-specificity `[hidden]` and silently keep an element visible (the same
    // trap that broke the calendar's empty spacer cells earlier).
    if (picker) picker.style.display = 'none';

    var pickerMode = null; // null | 'months' | 'years'
    var pickerYear = viewYear;
    var pickerRangeStart = viewYear - 5;

    var monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    function formatShort(date) {
      return monthNames[date.getMonth()].slice(0, 3) + ' ' + date.getDate() + ', ' + date.getFullYear();
    }

    function getHiddenField() {
      return document.getElementById('ContactForm-preferred-date');
    }

    function updateSelectedText() {
      var hiddenField = getHiddenField();
      if (!selectionStart) {
        selectedText.textContent = 'Select a start date, then an end date, to request Young Spirit for your event.';
        if (hiddenField) hiddenField.value = '';
        if (continueBtn) continueBtn.hidden = true;
        return;
      }
      if (selectionStart && !selectionEnd) {
        selectedText.textContent =
          'Selected: ' + formatShort(selectionStart) + ' — click an end date for a range, or continue below for a single day.';
        if (hiddenField) hiddenField.value = formatShort(selectionStart);
        if (continueBtn) continueBtn.hidden = false;
        return;
      }
      var text = formatShort(selectionStart) + ' to ' + formatShort(selectionEnd);
      selectedText.textContent = 'Selected: ' + text;
      if (hiddenField) hiddenField.value = text;
      if (continueBtn) continueBtn.hidden = false;
    }

    function onDayClick(clickedDate) {
      if (!selectionStart || (selectionStart && selectionEnd)) {
        selectionStart = clickedDate;
        selectionEnd = null;
      } else if (clickedDate.getTime() < selectionStart.getTime()) {
        selectionStart = clickedDate;
        selectionEnd = null;
      } else {
        selectionEnd = clickedDate;
      }
      updateSelectedText();
      render();
    }

    function closePicker() {
      pickerMode = null;
      if (picker) picker.style.display = 'none';
      if (weekdaysEl) weekdaysEl.style.display = '';
      grid.style.display = '';
    }

    function renderPicker() {
      pickerGrid.innerHTML = '';
      var pfrag = document.createDocumentFragment();

      if (pickerMode === 'months') {
        pickerLabel.textContent = pickerYear;
        for (var m = 0; m < 12; m++) {
          var mcell = document.createElement('button');
          mcell.type = 'button';
          mcell.className = 'ys-cal__picker-cell';
          mcell.textContent = monthNames[m].slice(0, 3);
          if (pickerYear === viewYear && m === viewMonth) {
            mcell.classList.add('is-current');
          }
          (function (mIndex) {
            mcell.addEventListener('click', function () {
              viewMonth = mIndex;
              viewYear = pickerYear;
              closePicker();
              render();
            });
          })(m);
          pfrag.appendChild(mcell);
        }
      } else if (pickerMode === 'years') {
        pickerLabel.textContent = pickerRangeStart + '–' + (pickerRangeStart + 11);
        for (var y = pickerRangeStart; y < pickerRangeStart + 12; y++) {
          var ycell = document.createElement('button');
          ycell.type = 'button';
          ycell.className = 'ys-cal__picker-cell';
          ycell.textContent = String(y);
          if (y === viewYear) {
            ycell.classList.add('is-current');
          }
          (function (yearValue) {
            ycell.addEventListener('click', function () {
              openMonthsPicker(yearValue);
            });
          })(y);
          pfrag.appendChild(ycell);
        }
      }

      pickerGrid.appendChild(pfrag);
    }

    function openMonthsPicker(year) {
      pickerMode = 'months';
      pickerYear = year;
      renderPicker();
      picker.style.display = 'block';
      if (weekdaysEl) weekdaysEl.style.display = 'none';
      grid.style.display = 'none';
    }

    function openYearsPicker(centerYear) {
      pickerMode = 'years';
      pickerRangeStart = centerYear - 5;
      renderPicker();
      picker.style.display = 'block';
      if (weekdaysEl) weekdaysEl.style.display = 'none';
      grid.style.display = 'none';
    }

    function render() {
      grid.innerHTML = '';
      monthBtn.textContent = monthNames[viewMonth];
      yearBtn.textContent = viewYear;

      var firstOfMonth = new Date(viewYear, viewMonth, 1);
      // Week starts Sunday: JS getDay() is already Sunday-first (0=Sun..6=Sat),
      // so it maps directly onto the SU..SA header row with no adjustment.
      var startWeekday = firstOfMonth.getDay();
      var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

      var frag = document.createDocumentFragment();

      for (var e = 0; e < startWeekday; e++) {
        var empty = document.createElement('div');
        empty.className = 'ys-cal__cell ys-cal__cell--empty';
        empty.setAttribute('aria-hidden', 'true');
        // A truly empty <div> matches Dawn's global `div:empty { display: none; }`
        // rule (base.css), which collapses it out of the grid entirely and shifts
        // every following day left. A non-breaking space keeps it non-empty so it
        // still takes up its grid column.
        empty.textContent = ' ';
        frag.appendChild(empty);
      }

      for (var d = 1; d <= daysInMonth; d++) {
        var date = new Date(viewYear, viewMonth, d);
        var cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'ys-cal__cell ys-cal__day';
        cell.textContent = String(d);

        var blocked = isBlocked(date);
        var isPast = date.getTime() < today.getTime();
        var isToday = date.getTime() === today.getTime();

        if (isToday) {
          cell.classList.add('ys-cal__day--today');
        }

        if (isPast) {
          cell.classList.add('ys-cal__day--past');
          cell.disabled = true;
        } else if (blocked && blocked.status === 'pending') {
          cell.classList.add('ys-cal__day--pending');
          cell.disabled = true;
          cell.title = 'Pending review';
        } else if (blocked) {
          cell.classList.add('ys-cal__day--booked');
          cell.disabled = true;
          cell.title = 'Booked: ' + blocked.label;
        } else {
          cell.classList.add('ys-cal__day--available');

          var isSingleSelected = selectionStart && !selectionEnd && date.getTime() === selectionStart.getTime();
          var isInRange =
            selectionStart && selectionEnd && date.getTime() >= selectionStart.getTime() && date.getTime() <= selectionEnd.getTime();

          if (isSingleSelected || isInRange) {
            cell.classList.add('ys-cal__day--selected');
          }

          (function (capturedDate) {
            cell.addEventListener('click', function () {
              onDayClick(capturedDate);
            });
          })(date);
        }

        frag.appendChild(cell);
      }

      grid.appendChild(frag);

      prevBtn.disabled = viewYear === today.getFullYear() && viewMonth === today.getMonth();
    }

    prevBtn.addEventListener('click', function () {
      viewMonth -= 1;
      if (viewMonth < 0) {
        viewMonth = 11;
        viewYear -= 1;
      }
      render();
    });

    nextBtn.addEventListener('click', function () {
      viewMonth += 1;
      if (viewMonth > 11) {
        viewMonth = 0;
        viewYear += 1;
      }
      render();
    });

    monthBtn.addEventListener('click', function () {
      if (pickerMode === 'months' && picker.style.display !== 'none') {
        closePicker();
      } else {
        openMonthsPicker(viewYear);
      }
    });

    yearBtn.addEventListener('click', function () {
      if (pickerMode === 'years' && picker.style.display !== 'none') {
        closePicker();
      } else {
        openYearsPicker(viewYear);
      }
    });

    pickerPrevBtn.addEventListener('click', function () {
      if (pickerMode === 'months') {
        pickerYear -= 1;
      } else if (pickerMode === 'years') {
        pickerRangeStart -= 12;
      }
      renderPicker();
    });

    pickerNextBtn.addEventListener('click', function () {
      if (pickerMode === 'months') {
        pickerYear += 1;
      } else if (pickerMode === 'years') {
        pickerRangeStart += 12;
      }
      renderPicker();
    });

    // Stop any click inside the picker (month/year cells, prev/next) from
    // reaching the document-level listener below. Without this, selecting a
    // year rebuilds the grid into months mode, which removes the very button
    // that was just clicked from the DOM — so by the time the click bubbles
    // up, `picker.contains(evt.target)` sees a detached node and wrongly
    // treats it as an outside click, instantly closing what just opened.
    if (picker) {
      picker.addEventListener('click', function (evt) {
        evt.stopPropagation();
      });
    }

    document.addEventListener('click', function (evt) {
      if (!picker || picker.style.display === 'none') return;
      if (picker.contains(evt.target) || monthBtn.contains(evt.target) || yearBtn.contains(evt.target)) return;
      closePicker();
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') closePicker();
    });

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        var nameField = document.getElementById('ContactForm-name');
        var target = nameField || document.getElementById('ContactForm');
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (nameField) {
          window.setTimeout(function () {
            nameField.focus();
          }, 400);
        }
      });
    }

    render();
    updateSelectedText();
  });
})();
